// deps
import React, { memo, ReactElement } from "react";

// internal deps
import { AriaHidden } from "@swiggy-private/core-ui";

// components
import { TickIcon } from "@cart-ui/widgets/tick-icon";

//constants
import { UX4_PRIMARY_ORANGE } from "@cart-ui/constants/Color";

import styles from "./styles/BenefitsItem.scss";

interface Props {
    title: string;
    subtitle?: string;
    subTextNode?: ReactElement;
}

const BenefitsItem: React.FC<Props> = ({ title, subtitle, subTextNode }: Props) => {
    return (
        <AriaHidden as="div" className={styles.benefitsItem}>
            <TickIcon className={styles.benefitsItemTickIcon} color={UX4_PRIMARY_ORANGE} />
            <span className={styles.benefitsItemTitle}>{title}</span>
            <span className={styles.benefitsItemSubTitle}>{subtitle}</span>
            {subTextNode}
        </AriaHidden>
    );
};

export default memo(BenefitsItem);
